import React, {useState, useEffect } from "react";
import { Link} from "react-router-dom";
import {
  Layout,
  Row,
  Col,
  Form,
  Tooltip,
  Popconfirm,
  Spin,Breadcrumb,
} from "antd";
import { useTranslation } from "react-i18next";
import {
  EditOutlined,
  DeleteOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { getRequest, postRequest } from "../../axios";
import { authUserData } from "../../utils/Helper";
import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
import SubscriptionNotification from "../../authentication/SubscriptionNotification";

const { Content } = Layout;

const VendorOnboardingStep = () => {
  const [companyProfileCount, setCompanyProfileCount] = useState(null);
  const [vendor, setVendor] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, settotalCount] = useState(0);
  const [gstNo, setGstNo] = useState([]);
  const [apiLoading, setapiloading] = useState(false);
  const [reload, setReload] = useState(false);
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10
  });
  const { t } = useTranslation();
  useEffect(() => {
    const getVendorList = async () => {
      setLoading(true);
      setapiloading(true);
      try {
        let apiResponse = await getRequest("vendor/get-vendor-company/", state);
        if (apiResponse.status) {
          setVendor(apiResponse.data.results.data);
          const suppliersBillingDetails =
            apiResponse.data.results.data.suppliers_billing_details;
          const gstNoValue = suppliersBillingDetails[0].gst_for_billing;
          setGstNo(gstNoValue);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_vendor_onboarding_list"));
        }
        setLoading(false);
        setapiloading(false);
      } catch (error) {
        setLoading(false);
        setapiloading(false);
      }
    };

    getVendorList();
  }, [state, reload, t]);


  const handleArchive = async (id) => {
    try {
      let apiResponse = await postRequest("vendor-delete/", {
        deleted: [id], 
      });
      if (apiResponse.data.success) {
        let totalArchive = totalCount - 1; 

        if (totalArchive < 11) {
          setState((prevState) => ({
            ...prevState,
            page: 1,
            search: "",
          }));
          setReload(!reload);
        } else {
          setReload(!reload);
        }
        SuccessNotificationMsg(apiResponse.data.message);
      } else {
        if (Array.isArray(apiResponse.data.message)) {
          ErrorNotificationMsg(apiResponse.data.message.join(', '));
        } else {
          ErrorNotificationMsg(apiResponse.data.message);
        }
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        page: 1,
        search: "",
      }));
    }
  };

  useEffect(() => {
    const fetchedData = authUserData()?.company_profile_count?.[0];
    if (fetchedData) {
      setCompanyProfileCount(fetchedData);
    } else {
      console.error("Company profile count data is missing or empty.");
    }
  }, [authUserData]);

  const incompleteModules = companyProfileCount
    ? Object.entries(companyProfileCount)
      .filter(([key, value]) => typeof value === "number" && value === 0)
      .map(([key]) => {
        switch (key) {
          case "company_material_perc":
            return "Company Material";
          case "site_location_perc":
            return "Site Location";
          case "user_role_perc":
            return "User Role";
          case "employee_perc":
            return "Employee";
          case "pr_release_perc":
            return "PR Release";
          case "business_setting_perc":
            return "Business Setting";
          case "vendor_perc":
            return "Vendor";
          default:
            return null;
        }
      })
      .filter((module) => module !== null)
    : [];

  return (
    <>
         <div className="ListingTopBar">
                  <div className="pagenamewrap">
                    <div className="pagename">
                    
                      <h3>Vendor Onboarding</h3>
          
                      <Breadcrumb className="Breadcrumb-Sec">
                        <Breadcrumb.Item>
                          <Link to="/dashboard">Dashboard</Link>
                        </Breadcrumb.Item>
          
                        <Breadcrumb.Item>Vendor Onboarding</Breadcrumb.Item>
                      </Breadcrumb>
                      </div>
                    <div className="pgnmbtns">
                         <Tooltip placement="topLeft" title="Archived Records">
                <Link to="/vendor/archive" className="Archiveicon" >
                  <Archiveicon />
                </Link>
              </Tooltip>
                               </div>
                    
                  </div>
                </div>
    
       
          <Content className="stepscontentwrap">
           {
          authUserData().company_role === "Company Admin" && authUserData().employee === null && <SubscriptionNotification />
        }
           
            <div className="stepsContent">
  <Spin spinning={apiLoading}>

              <div className="cardswraper">
                <Row gutter={24}>
                  <Col xs={24} sm={24} md={12} xl={8} xxl={6}>
                    <div className="stepcard addsite">
                      <div>
                        <Link to="/vendor/add">
                          <PlusCircleOutlined />
                        </Link>
                        <h5>Add Vendor</h5>
                      </div>
                    </div>
                  </Col>

                  {vendor.map((vendor) => (
                    <Col xs={24} sm={24} md={12} xl={8} xxl={6} key={vendor.id}>
                      <div className="stepcard sitecard">
                        <div className="cardtitle">
                          {vendor.vendor_trade_name}
                          <div className="action">
                            <Link
                              to={`/vendor/edit/${vendor.id}`}
                            >
                              <EditOutlined />
                            </Link>
                            <Popconfirm
                              className="action"
                              title={t("pop_title")}
                              okText={t("pop_ok")}
                              cancelText={t("pop_cancel")}
                              onConfirm={() => handleArchive(vendor.id)}
                            >
                              <DeleteOutlined />
                            </Popconfirm>
                          </div>
                        </div>

                        <Row gutter={16}>
                          <Col xs={24}>
                            <Form.Item>
                              <label>Legal Name of Business </label>
                              <span className="value">
                                {" "}
                                {vendor.vendor_registered_name}
                              </span>
                            </Form.Item>
                          </Col>
                          <Col xs={24}>
                            <Form.Item>
                              <label>GSTN </label>
                              <span className="value"> {vendor.gst_no}</span>
                            </Form.Item>
                          </Col>
                          <Col xs={24}>
                            <Form.Item>
                              <label>Address </label>
                              <span className="value">
                                {vendor.trading_address_building}
                              </span>
                            </Form.Item>
                          </Col>
                          <Col xs={24}>
                            <Form.Item>
                              <label>Email </label>
                              <span className="value"> {vendor.email}</span>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
              </Spin>
            </div>

          </Content>
       
 
 
    </>
  );
};

export default VendorOnboardingStep;
